import React, { FC } from 'react';
import {
  Checkbox,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import lodashGet from 'lodash/get';
import { useTranslate } from 'react-admin';
import { TableContentProps } from '~/types/AccountTableMultiselect';

const TableContent: FC<TableContentProps> = ({
  rows,
  isSelected,
  handleToggleSelect,
  optionText,
  children,
  tableProps,
  hasSelection,
  handleDeselectAll,
  selectionControl = 'checkbox',
}) => {
  const translate = useTranslate();
  const t = (key: string) => translate(`components.ra.fields.AccountTableMultiselect.${key}`);
  const displayedRows = rows;
  const SelectionControl = selectionControl === 'radio' ? Radio : Checkbox;

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell padding='checkbox'>
            {selectionControl === 'checkbox' && (
              <Checkbox
                checked={hasSelection}
                disabled={!hasSelection}
                indeterminate
                onClick={handleDeselectAll}
                title={t('deselectAll')}
              />
            )}
          </TableCell>
          {tableProps?.headers ? (
            tableProps.headers.map((header, idx) => <TableCell key={idx}>{header}</TableCell>)
          ) : (
            <TableCell>{t('accountNumber')}</TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {displayedRows?.map((item, index, arr) => {
          return (
            <TableRow
              hover
              key={item.id}
              selected={isSelected(item.id)}
              onClick={() => handleToggleSelect(item as any)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell padding='checkbox' onClick={(e) => e.stopPropagation()}>
                <SelectionControl
                  checked={isSelected(item.id)}
                  onChange={() => handleToggleSelect(item as any)}
                />
              </TableCell>
              {tableProps?.renderRow ? (
                tableProps.renderRow(item, index, arr)
              ) : (
                <TableCell>
                  {typeof children === 'function'
                    ? children(item, index, arr)
                    : typeof optionText === 'string'
                    ? lodashGet(item, optionText) || ''
                    : optionText(item)}
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default TableContent;
